export enum ChangeType {
  ITEM_UPDATED = 'ITEM_UPDATED',
  ITEM_INSERTED = 'ITEM_INSERTED',
  ITEM_DELETED = 'ITEM_DELETED',
}
